import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../../Localstorage/localstorage";
import MailboxKlant from "./MailboxKlant";
import MailboxAdmin from "./MailboxAdmin";
import MailList from "./MailList";
import RPDrawerMessaging from "../../Componenten/Drawers/RPDrawerMessaging";
import { setCommand } from "../../redux/mailSlice";
import { IOSOCKETCLIENT, setIOSocketListeners } from "../../linksocket/linksocket";
import { MAKE_SOCKET_CHANNEL, SOCKET_CHANNELS } from "../../constants/constants";
import { fetchMailMessages, fetchMailUnreadCount } from "../../apiCalls/messageApi";
import { wa } from "./mailWaTheme";

const MailBox = () => {
  const user = getUser();
  const [openDialog, setOpenDialog] = useState(false);
  const [mobileChatOpen, setMobileChatOpen] = useState(false);
  const [roomsRefreshToken, setRoomsRefreshToken] = useState(0);
  const dispatch = useDispatch();
  const { mailMessage } = useSelector((state) => state.mail);

  const getMail = useCallback(async () => {
    await Promise.all([
      fetchMailMessages(user, dispatch),
      fetchMailUnreadCount(user, dispatch),
    ]);
  }, [dispatch, user?.id]);

  const refreshMail = useCallback(
    () => {
      fetchMailMessages(user, dispatch);
      fetchMailUnreadCount(user, dispatch);
      setRoomsRefreshToken((value) => value + 1);
    },
    [user, dispatch]
  );

  useLayoutEffect(() => {
    if (user?.id) {
      getMail();
    }
  }, [user?.id, getMail]);

  const prevChannelRef = useRef();

  useEffect(() => {
    if (user?.id && mailMessage?.id) {
      const channel = MAKE_SOCKET_CHANNEL(mailMessage?.id, SOCKET_CHANNELS.MAIL_ITEM);

      if (prevChannelRef.current === channel) return;

      prevChannelRef.current = channel;
      const cleanupSocketListener = setIOSocketListeners(
        channel,
        SOCKET_CHANNELS.MAIL_ITEM,
        refreshMail
      );
      return () => {
        if (cleanupSocketListener) {
          cleanupSocketListener();
        } else {
          IOSOCKETCLIENT.emit("JOINLEAVEROOM", { action: "leave", channel });
        }
        if (prevChannelRef.current === channel) {
          prevChannelRef.current = undefined;
        }
      };
    }
  }, [user, mailMessage?.id, refreshMail]);

  const openModal = (p_type = "insert") => {
    dispatch(setCommand(p_type));
    setOpenDialog(true);
  };

  const handleConversationOpen = () => {
    setMobileChatOpen(true);
  };

  const handleExitMobileChat = () => {
    setMobileChatOpen(false);
  };

  return (
    <div className={`flex h-full min-h-0 w-full flex-1 flex-col ${wa.app}`}>
      <div className="flex min-h-0 flex-1 overflow-hidden">
        <main className="flex min-h-0 min-w-0 flex-1 flex-col md:flex-row">
          {user?.role === 1 ? (
            <MailboxAdmin
              setOpenModal={openModal}
              onConversationOpen={handleConversationOpen}
              mobileChatOpen={mobileChatOpen}
              roomsRefreshToken={roomsRefreshToken}
            />
          ) : (
            <MailboxKlant
              setOpenModal={openModal}
              onConversationOpen={handleConversationOpen}
              mobileChatOpen={mobileChatOpen}
              roomsRefreshToken={roomsRefreshToken}
            />
          )}
          <MailList
            setOpen={setOpenDialog}
            mobileChatOpen={mobileChatOpen}
            onExitMobileChat={handleExitMobileChat}
          />
        </main>
      </div>
      <RPDrawerMessaging open={openDialog} setOpen={setOpenDialog} />
    </div>
  );
};

export default MailBox;
